<div class="trading-report" id="tradeReport">
  <!-- for web view -->
  @if (!isMobile && !isPrint) {
    <app-trading-report-web></app-trading-report-web>
  }
  <!-- for mobile view -->
  @if (isMobile && !isPrint) {
    <app-trading-report-mobile></app-trading-report-mobile>
  }

  @if (isPrint) {
    <div>
      <app-print-profits class="page-break"
        [strategyTrades]="firstStrategyTrades"
        [tradingStrategy]="firstTradingStrategy"
        [isReportFitOnPrintScreen]="isReportFitOnPrintScreen"
      ></app-print-profits>
      <app-print-profits class="page-break"
        [strategyTrades]="secondStrategyTrades"
        [tradingStrategy]="secondTradingStrategy"
        [isReportFitOnPrintScreen]="isReportFitOnPrintScreen"
      ></app-print-profits>
    </div>
  }

</div>
